import defaultRole from "constant/config.role";

export const profile = {
    id: `dashboard`,
    title: `Dashboard`,
    type: `group`,
    children: [
        {
            id: `default`,
            title: `Dashboard`,
            type: `item`,
            url: `${process.env.REACT_APP_DC_URL}profile/services`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `services`,
            title: `Services`,
            type: `item`,
            url: `${process.env.REACT_APP_FHT_URL}login`,
            icon: `gridView`,
            breadcrumbs: false,
            href: true,
        },
        {
            id: `member_portal`,
            title: `Member Portal`,
            type: `collapse`,
            url: `${defaultRole.profile}/portal/dashboard`,
            icon: `gridView`,
            breadcrumbs: false,
            children: [
                {
                    id: `default`,
                    title: `Dashboard`,
                    type: `item`,
                    url: `${defaultRole.profile}/portal/dashboard`,
                    icon: `gridView`,
                    breadcrumbs: false,
                    parentId: "member_portal"
                }
            ]
        },
    ]
};